import { css } from 'goober';
import React from 'react';
import colors from '../../styles/colors';
import { transparentize } from '../../styles/mixins';
import CoachMark from '../CoachMark';
const Box = css `
  position: absolute;
  top: 0;
  bottom: 0;
  background: ${transparentize(0.7, colors.black)};
  width: 100%;
  height: 100%;
  pointer-events: none;
`;
const CoachMarkStyles = css `
  position: absolute;
  right: 29px;
  top: 35%;
  margin: auto 0 auto auto;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  pointer-events: none;
`;
const CoachMarkStyles2 = css `
  position: absolute;
  right: 27px;
  top: 35%;
  margin: auto 0 auto auto;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
`;
const CoachMarkContainer = (props) => {
    const { isLastStoryInCard, hasTapHere } = props;
    if (isLastStoryInCard || hasTapHere) {
        return (React.createElement("div", { className: Box },
            React.createElement(CoachMark, { coachMarkText: !isLastStoryInCard
                    ? 'Tap here for <br/>the next story'
                    : 'Swipe Left For<br/> The Next Trend', index: 0, showTransition: isLastStoryInCard, CoachMarkStyles: !isLastStoryInCard ? CoachMarkStyles : CoachMarkStyles2, isTappable: !isLastStoryInCard })));
    }
    return null;
};
export default CoachMarkContainer;
//# sourceMappingURL=index.js.map